import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_jewelry_earrings: FaireCategoryEntity = {
  token: "cat_jewelry-earrings",
  type: "category",
  name: "Earrings",
  level: 2,
  parentToken: "cat_jewelry",
  href: "/category/jewelry/earrings",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
